'use client';

import { c as _c } from "react/compiler-runtime";
import useEmblaCarousel from 'embla-carousel-react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import type { CSSProperties } from 'react';
import { useCallback, useEffect } from 'react';
import { IntentPrefetchLink } from '@/components/ui/intent-prefetch-link';
import type { AnnouncementBarMessage } from './site-header.shared';
interface SiteHeaderAnnouncementBarProps {
  messages: AnnouncementBarMessage[];
  style?: CSSProperties;
}
export function SiteHeaderAnnouncementBar(t0) {
  const $ = _c(30);
  const {
    messages,
    style
  } = t0;
  const t1 = messages.length > 1;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      align: "center",
      containScroll: "trimSnaps",
      dragFree: false,
      loop: t1,
      skipSnaps: false
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [announcementEmblaRef, announcementEmblaApi] = useEmblaCarousel(t2);
  let t3;
  if ($[2] !== announcementEmblaApi) {
    t3 = () => announcementEmblaApi?.scrollPrev();
    $[2] = announcementEmblaApi;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const scrollAnnouncementPrev = t3;
  let t4;
  if ($[4] !== announcementEmblaApi) {
    t4 = () => announcementEmblaApi?.scrollNext();
    $[4] = announcementEmblaApi;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const scrollAnnouncementNext = t4;
  let t5;
  let t6;
  if ($[6] !== announcementEmblaApi || $[7] !== messages.length) {
    t5 = () => {
      if (messages.length <= 1 || !announcementEmblaApi) {
        return;
      }
      const interval = setInterval(() => {
        announcementEmblaApi.scrollNext();
      }, 4000);
      return () => clearInterval(interval);
    };
    t6 = [messages.length, announcementEmblaApi];
    $[6] = announcementEmblaApi;
    $[7] = messages.length;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== messages.length || $[11] !== scrollAnnouncementPrev) {
    t7 = messages.length > 1 && <button type="button" onClick={scrollAnnouncementPrev} className="absolute left-0 top-1/2 -translate-y-1/2 p-1 transition-opacity hover:opacity-80" aria-label="Previous announcement"><ChevronLeft className="h-4 w-4" /></button>;
    $[10] = messages.length;
    $[11] = scrollAnnouncementPrev;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== messages) {
    t8 = messages.map(_temp);
    $[13] = messages;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <div className="flex">{t8}</div>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== announcementEmblaRef || $[18] !== t9) {
    t10 = <div ref={announcementEmblaRef} className="min-w-0 flex-1 overflow-hidden cursor-grab active:cursor-grabbing">{t9}</div>;
    $[17] = announcementEmblaRef;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== messages.length || $[21] !== scrollAnnouncementNext) {
    t11 = messages.length > 1 && <button type="button" onClick={scrollAnnouncementNext} className="absolute right-0 top-1/2 -translate-y-1/2 p-1 transition-opacity hover:opacity-80" aria-label="Next announcement"><ChevronRight className="h-4 w-4" /></button>;
    $[20] = messages.length;
    $[21] = scrollAnnouncementNext;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t7) {
    t12 = <div className="container-page"><div className="relative flex min-h-9 items-center px-8 py-2 sm:px-10">{t7}{t10}{t11}</div></div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== style || $[28] !== t12) {
    t13 = <div className="border-b border-black/10" style={style}>{t12}</div>;
    $[27] = style;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
function _temp(message) {
  return <div key={`${message.link || "message"}-${message.text}`} className="min-w-0 shrink-0 basis-full text-center text-[11px] font-semibold uppercase tracking-[0.12em]">{message.link ? <IntentPrefetchLink href={message.link} className="transition-opacity hover:opacity-80">{message.text}</IntentPrefetchLink> : <span>{message.text}</span>}</div>;
}